'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@algoacademy/design-system/web/actions/Button';
import { VerticalSpacer } from '@algoacademy/design-system/web/layouts/VerticalSpacer';
import { H1 } from '@algoacademy/design-system/web/marketing/typography/Heading';
import { P1 } from '@algoacademy/design-system/web/marketing/typography/Paragraph';
import { ChevronDoubleDownIcon } from '@heroicons/react/24/solid';
const scrollToFirstCourses = () => {
  const firstCoursesElement = document.querySelector('[data-scroll-to-first-courses]');
  firstCoursesElement?.scrollIntoView({
    behavior: 'smooth'
  });
};
export function TopSection() {
  const $ = _c(5);
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <H1>Kursy</H1>;
    t1 = <VerticalSpacer size="content" />;
    t2 = <P1>W AlgoAcademy prowadzimy kursy z różnych dziedzin informatyki dla osób o różnorodnych potrzebach. Niezależnie, czy jesteś uczniem, studentem lub pasjonatem tej dziedziny – znajdziesz u nas coś dla siebie!</P1>;
    t3 = <VerticalSpacer size="button" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <section className="mx-auto max-w-xl text-center">{t0}{t1}{t2}{t3}<Button size="xl" onClick={scrollToFirstCourses} className="w-full lg:w-fit">Nasze kursy<ChevronDoubleDownIcon /></Button></section>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}